<template>
  <div class="Aviso">
    <headNav :activeNav="'loan'"></headNav>
    <img
      src="../assets/image/3_banner.png"
      style="height: auto"
      class="banner"
      alt=""
    />
    <div class="bigContent">
      <h1 class="title">
        TÉRMINOS Y CONDICIONES DE PRÉSTAMO - APLICACIÓN LUCKYPLATA
      </h1>
      <div class="content">
        <p>
          <span class="title">Doowin S.A.S.</span> (en lo sucesivo “ DOOWIN
          S.A.S .”) sociedad comercial identificada con NIT. 901.493.980 - 6 , a
          través de nuestro portal https://www.luckyplata.co/home (en lo
          sucesivo la “página web”), así como también en su aplicación, misma
          que se encuentra disponible para los dispositivos móviles con sistema
          operativo Android, cuya denominaci ón es “ LUCKYPLATA ” (en lo
          sucesivo la “Aplicación”), se advierte que al momento de que el
          usuario realice la solicitud de un préstamo, este último otorga su
          consentimiento pleno y sin reserva alguna respecto al Aviso de
          Privacidad y /o Política de Tratamien to de Datos Personales , para el
          manejo de sus datos personales y así mismo, se sujetara a los Términos
          y Condiciones que son aplicables en caso de que el préstamo sea
          autorizado para ser otorgado.
        </p>
        <p>
          Los productos y servicios que ofrece “ Doowin S.A.S.”, están dirigidos
          única y exclusivamente a personas físicas colombianas que cuenten con
          capacidad legal para contratar, dando como conclusión que expresamente
          están excluidos las personas que sean menores de edad, las aquellas
          declaradas judicialmente como en estado de interdicción u aquellas
          limitadas por cualquier otro contrato, convenio o relación comercial,
          estos siempre se entenderán de manera enunciativa más no
          limitativamente.
        </p>
        <p>
          Los Servicios ofrecidos por Doowin S.A.S. a través de la Página Web
          y/o la Aplicación serán válidos única y exclusivamente en el
          territorio colombiano , por lo que en caso de que la Página Web y/o la
          Aplicación pudieran ser accedidos desde diversos países alrededor del
          mundo, esto en ningún caso imp licará que Doowin S.A.S. autorice o
          habilite sus servicios y/o contenidos en tales países o en diversas
          jurisdicciones.
        </p>
        <p>
          Es así que, para mayor entendimiento del usuario ponemos a su
          disposición los siguientes Términos y Condiciones:
        </p>
        <p>
          <span class="title">1. Aceptación. </span> - El usuario entiende y
          acepta que al ingresar y navegar en la Página Web y/o la Aplicación,
          manifiesta de forma su voluntad plena y sin reservas de quedar sujeto
          a los presentes Términos y Condiciones, los cuales, tienen carácter
          obligatorio y vincula nte, por lo que, en caso de no aceptar o no
          estar de acuerdo con estos Términos y Condiciones, y/o con el Aviso de
          Privacidad de Doowin S.A.S., deberá abstenerse de continuar navegando
          en la Página Web, así como de utilizar la Aplicación. En e ste
          sentido, es responsabilidad del usuario leer y entender íntegramente
          las condiciones establecidas en el presente documento, antes de
          realizar cualquier gestión dentro de la Página Web y/o de registrarse
          y solicitar cualquier servicio en la Aplicación.
        </p>
        <p>
          <span class="title"
            >2. Uso debido y restricciones del Software y Hardware.</span
          >
          - Toda persona que acceda, mediante el uso de un equipo de cómputo,
          tableta, celular y/o cualquier otro dispositivo con acceso a Internet
          a la Aplicación y/o a la Página Web, está de acuerdo en no utiliza r
          dichos dispositivos, programas de cómputo, software, o cualquier otro
          medio para interferir o afectar, tanto las funcionalidades,
          actividades y/u operaciones de la Aplicación y/o del Página Web, así
          como las bases de datos y/o información que se contenga en los mismos.
          El usuario acepta que es responsable de contar con software y hardware
          compatible, los dispositivos necesarios, conexión a la red de
          Internet, y cualquier otro requerimiento técnico necesario para la
          correcta ejecución de la Aplicación y/o de la Página Web. El usuario
          entiende que si accede o utiliza la Aplicación y/o navega en la Página
          Web desde un dispositivo móvil, podrán aplicarse las tarifas y tasas
          de datos y mensajes de su proveedor de red móvil, sin responsabilidad
          alguna para Doowin S.A.S.
        </p>
        <p>
          <span class="title"
            >3. Restricciones Legales en materia de Prevención de Lavado de
            Dinero.</span
          >
          - Doowin S.A.S. y el usuario se obligan a realizar todas las
          actividades encaminadas a asegurar que todo su personal a cargo,
          empleados, socios, accionistas, administradores, clientes,
          proveedores, etc., y los recursos de estos, no se encuentren
          relacionados o provengan , de actividades ilícitas; particularmente,
          de lavado de activos o financiación del terrorismo. En todo caso, si
          durante el plazo de vigencia del préstamo se encontraren en alguna de
          las partes, dudas razonables sobre sus operaciones, así como el origen
          de sus activos y/o que alguna de ellas, llegare a resultar inmiscuido
          en una investigación de cualquier tipo (penal, administrativa, etc.)
          relacionada con actividades ilícitas, lavado de dinero o
          financiamiento del terrorismo, o fuese incluida en las listas
          internacionales vinculantes para Colombia de conformidad con el
          derecho internacional (listas de naciones unidas - ONU), en listas de
          la OFAC o Clinton, etc., la parte libre de reclamo tendrá derecho de
          terminar unilateralmente el mutuo con interés sin que por este hecho,
          esté obligado a indemnizar ningún tipo de perjuicio a la parte que lo
          generó.
        </p>
        <p class="title">
          4. Del Registro, Solicitud de Préstamo, Otorgamiento Préstamo y Pago.
        </p>
        <p>
          <span class="title"
            >I. Registro/Creación, Inhabilitación y Cancelación de cuenta.</span
          >
          - Todo usuario que pretenda sol icitar los productos y servicios con
          Doowin S.A.S. primero deberá registrarse a través de la Aplicación y/o
          en la Página Web, mediante la creación de un usuario y contraseña a
          través del llenado de la solicitud correspondiente en todos sus cam
          pos; pudiendo optar, en caso de estar habilitada la opción, el
          registro de su usuario y contraseña con el enlace con sus redes
          sociales, esto para agilizar la creación de su cuenta, dando como
          resultado que Doowin S.A.S. tome únicamente los dat os necesarios para
          realizar su registro.
        </p>
        <p>
          El usuario se obliga a mantener la confidencialidad de su Contraseña,
          pues entiende que será responsable por todas las operaciones
          efectuadas en y desde su cuenta, toda vez que el acceso a la misma
          está restringid o al ingreso y uso de su contraseña, la cual es de su
          conocimiento exclusivo.
        </p>
        <p>
          Inhabilitación de la cuenta. Sin perjuicio de otras medidas, Doowin
          S.A.S. podrá suspender, sin requisito o formalidad alguna, en forma
          temporal o inhabilitar definitivamente la cuenta del usuario y/o
          suspender la prestación de sus servicios si el usuario: (a)
          Trasgrediera alguna ley, o cualquiera de las estipulaciones de los p
          resentes Términos y Condiciones. (b) Incumpliera sus compromisos como
          usuario. (c) Incurriera a criterio de DOOWIN S.A.S . en conductas o
          actos fraudulentos. (d) No pudiera verifi carse la identidad del
          usuario o cualquier información proporcionada por el mismo fuere
          errónea o falsa.
        </p>
        <p>
          Eliminación de cuenta. El Usuario podrá cancelar en cualquier momento
          su cuenta, siempre y cuando no exista alguna obligación de pago
          pendiente a favo r de DOOWIN S.A.S .
        </p>
        <p>
          <span class="title">II. Datos Personales.</span> - El usuari o deberá
          llenar todos y cada uno de los campos en donde proporcionará los datos
          de identificación del cliente, como lo son ; número de identificación
          nombre s y apellido s , fecha de nacimiento, fecha de expedición del
          documento , dirección de domicilio, númer o telefónico, nombre s y
          números de teléfono de las referencias, número de cuenta bancaria en
          donde se depositara n los recursos en dado caso de que sea autorizado
          el préstamo que solicitó, en este acto de la misma manera el mismo
          usuario otorga su pleno co nsentimiento a Doowin S.A.S. , para que se
          de uso y tratamiento de sus datos personales, tal y como de la misma
          manera se referencia en el Aviso de Privacidad y en la Política de
          Tratamiento de Datos Personales que pone a disposición del público en
          general a través de la página web https://www.luckyplata.co/ .
        </p>
        <p>
          <span class="title"
            >III. Confirmación de Usuario y Restricciones.</span
          >
          - Una vez ingresados los datos requeridos, el usuario recibirá un
          número de confirmación al número de teléfono celular que indicó en la
          Aplicación y/o Página web, esto como parte del proceso para la
          autenticación y verificación de su identidad, dicha confirmación
          deberá realizarse ingresa ndo a la Aplicación y / o Pagina web para
          concluir con el registro. El envío de dichos códigos se entenderá por
          parte de Doowin S.A.S. que fue realizado por solicitud del usuario.
        </p>
        <p>
          De la misma manera, se le solicitara al usuario que dentro del mismo
          proceso, realice u na fotografía de su cédula de ciudadanía por el
          anverso y el reverso de la misma, lo anterior es necesario para
          comprobar por parte de Doowin S.A.S. que el usuario es mayor de edad y
          puede celebrar cualquier tipo de contrato no importando la n aturaleza
          de este, posteriormente se le solicitará que el usuario se tome una
          fotografía con su cédula de ciudadanía por el anverso y el reverso de
          la misma , esto es para comprobar de la misma manera por parte de
          Doowin S.A.S. que el usuario q ue registro su cuenta es la misma
          persona que está solicitando el préstamo y que posee la mayoría de
          edad.
        </p>
        <p>
          Doowin S.A.S. se reserva el derecho de solicitar documentación
          adicional con el fin de corroborar los datos ingresados en la
          solicitud, así como de suspender temporal o definitivamente las
          cuentas y/o negar las solicitudes de aquellos usuarios cuyos datos no
          hayan podido ser confirmados, sean detectados como alterados o
          falsificados.
        </p>
        <p>
          La cuenta dentro de la Aplicación o en la Página Web e s de carácter
          personal, única e intransferible, por lo cual, Doowin S.A.S. le tiene
          terminantemente prohibido al titular de la cuenta que un mismo usuario
          inscriba o posea más de una cuenta dentro de la página o dentro de la
          aplicación. En caso de que Doowin S.A.S. detecte distintas cuentas que
          contengan datos que coincidan , podrá cancelar, suspender o
          inhabilitarlas, sin responsabilidad alguna , con el fin de velar por
          la seguridad de la misma .
        </p>
        <p>
          <span class="title">IV. Solicitud de Préstamo.</span> - Una vez creada
          la cuenta por parte del usuario este podrá dentro de la aplicación o
          la página web solicitar el préstamo hasta por un máximo de
          $1,200,000.00 COP, sin embargo, DOOWIN S.A.S . evaluará el nivel de
          rie sgo que representa el usuario, la cantidad autorizada, sin ser
          obligación para DOOWIN S.A.S . el otorgamiento máximo.
        </p>
        <p>
          Se hace el puntual señalamiento que hasta en tanto no se haya
          notificado dentro de la aplicación o en la página web al usuario por
          parte de Doowin S.A.S. la autorización del préstamo, no se entenderá
          perfeccionado ningún otorgamiento del mismo préstamo, por dicho
          motivo, el usuario entiende que la aceptación de los presentes
          Términos y Condiciones no representa ofrecimiento formal alguno por pa
          rte de Doowin S.A.S. y no implica que el préstamo haya sido o que será
          autorizado.
        </p>
        <p>
          <span class="title"
            >V. De la Obligación de Pago, los plazos para liquidar el préstamo,
            intereses corrientes e intereses moratorios.</span
          >
          - Todo usuario que le sea autorizado un préstamo por parte de Doowin
          S.A.S. , no importando la cantidad del mismo, ac e pta que tiene
          conocimiento de estos Términos y Condiciones al momento de aceptarlos
          está realizando un acto contractual de ma nera electrónica en el cual
          el mismo solicitante adquiere una deuda por el monto que le haya sido
          autorizada por Doowin S.A.S. , por lo anterior, es de conocimiento del
          usuario que dicho préstamo se generará un interés ponderado de una
          tasa efec tiva anual de 24% sobre el total de saldos insolutos, ahora
          bien, en caso de que el usuario incumpla con la obligación de pago
          sobre el total del préstamo se aumentará un interés moratorio por
          falta de pago, hasta que el usuario decida finiquitar la deuda .
        </p>
        <p>
          El usuario con previa notificación a Doowin S.A.S. a través de un
          escrito, comunicación electrónica o llamada telefónica, podrá realizar
          el pago parcial a través de transferencia electrónica y/o a través de
          algún prestador de servicios , autorizados por Doowin S.A.S. y que
          tenga suscrito un convenio, dicha información será pública a través de
          la página web https://www.luckyplata.co/home .
        </p>
        <p>
          El plazo máximo para realizar el pago del préstamo y los intereses
          pactados dependerá directamente del monto otorgado y el riesgo
          considerado, este podrá pactarse con un mínimo de 8 días y el plazo
          máximo para esto será de 9 1 días calendario .
        </p>
        <p>
          <span class="title">
            VI. Manejo y Uso de la Cuenta no autorizado por el Us uario.
          </span>
          - En el entendido del numeral I de que el usuario es responsable de la
          cuenta y de sus contraseñas, en caso de que estas fueran extraviadas,
          robadas o cualquier situación que se presentara en el momento presente
          o futuro, el usuario tiene la obligación leg al de notificar a DOOWIN
          S.A.S . en forma inmediata por escrito, vía electrónica o telefónica
          cualquier uso no autorizado de su cuenta, así como el ingreso por
          terceros no autorizados a la misma, por lo tanto, se advierte que al
          momento de que el usuario r ealiz a el registro de su cuenta le queda
          terminantemente prohibido por parte de DOOWIN S.A.S . realizar la
          venta, cesión o transferencia de la cuenta.
        </p>
        <p>
          De lo anteriormente señalado, DOOWIN S.A.S . no se hará responsable,
          por errores generales o tipográfico s en los cuales incurra el usuario
          o por negligencia al usar los servicios de la Aplicación y/o la Página
          Web, de igual forma DOOWIN S.A.S . se exime de responsabilidad ante
          negligencia al dejar cualquier dispositivo electrónico, mediante el
          cual tenga acce so a la App, la Página Web y los servicios, sin
          atención alguna, reservándose el derecho de rechazar cualquier
          solicitud de registro o de cancelar una solicitud previamente
          aceptada, sin que esté obligado a exponer las razones de su decisión y
          sin que ello genere algún derecho a indemnización al usuario.
        </p>
        <p>
          <span class="title">VII. Env ío de Publicidad y Mercadotecnia.</span>
          - El usuario otorga su consentimiento a “ Doowin S.A.S. ” para que se
          le envié mensajes de texto y/u otro medio para hacerle llegar
          publicidad relacionada con los Servicios que ofrece y/o para que sus
          datos personales sean utilizados con fines de mercadeo y/o
          publicitarios.
        </p>
        <p>
          <span class="title"
            >VIII. Publicidad de los términos y condiciones a disposición del
            Público.</span
          >
          - Doowin S.A.S. podrá establecer diversos requisitos de
          contratación/elegibilidad para cada uno de sus productos, mismos que
          pueden consultarse en la Página Web.
        </p>
        <p>
          <span class="title"
            >IX. Modificaciones de los Términos y Condiciones.</span
          >
          Doowin S.A.S. podrá modificar los Términos y Condiciones en cualquier
          momento, haciéndo los públicos en la Aplicación o en la Página Web los
          términos modificados. En caso de desacuerdo del usuario respecto de
          los cambios realizados, deberá comunicarlo por el correo electrónico
          servicio@luckyplata.co a la siguiente cuenta
          https://www.luckyplata.co/home dentro de los 5 (cinco) días siguientes
          a la publicación de las modificaciones; en ese caso será cancelada la
          cuenta del usuario siempre que no subsistan montos pendientes a favor
          de Doowin S.A.S. Vencido este plazo, sin oposición del usuario se
          considerará que este acepta los nuevos Términos y Condiciones.
        </p>
        <p>
          <span class="title">X. Propiedad Intelectual.</span> - El usuario no
          adquirirá bajo ninguna circunstancia licencia o derecho alguno sobre
          la propiedad intelectual de Doowin S.A.S. por el mero uso de su A pp,
          la Página Web o de sus servicios; por lo tanto, su uso no podrá ser
          considerado como una autorización tácita o expresa para utilizar los
          sistemas y contenidos con algún fin diverso a los contemplados por el
          presente documento.
        </p>
        <p>
          El usuario reconoce y acepta que la App, la Página Web y cualquier
          software que sea necesario para permitirle acceder y usar su cuenta
          para solicitar y recibir los servicios de DOOWIN S.A.S ., contienen
          información confidencial de DOOWIN S.A.S . y/o de terceros, que se
          encuentra protegida por las leyes de propiedad intelectual y otras
          leyes aplicables, asimismo, el usuario reconoce que el contenido que
          consta en la Aplicación y la Página Web d e DOOWIN S.A.S ., son de la
          titularidad y propiedad exclusiva de DOOWIN S.A.S . y por consecuencia
          sus derechos de uso y explotación que incluyen mas no se limitan a su
          publicación, reproducción, divulgación, transformación y distribución
          le corresponden úni camente a DOOWIN S.A.S . y están protegidas por
          las normas nacionales e internacionales de D erecho de A utor y
          Propied a d Industrial.
        </p>
        <p>
          Cualquier contravención a lo anteriormente expuesto o a la legislación
          aplicable en materia de propiedad intelectual, industrial, derechos de
          autor será considerada y perseguida como un delito. En consecuencia,
          el usuario entiende que le queda prohibido da r uso indebido, así como
          reproducir total o parcialmente dichos sistemas y contenidos.
        </p>
        <p>
          <span class="title">XI. Contacto.</span> - Doowin S.A.S. estará a
          disposición del usuario en su domicilio localizado en CL 89 95 F 27
          Bogotá D.C., correo electrónico servicio@luckyplata.co en un horario
          de 9 9:00 a 18:00 horas de lunes a v viernes .
        </p>
        <p>
          <span class="title"
            >XII. Notificaciones, jurisdicción y ley aplicable.</span
          >
          - Todos los avisos y notificaciones que las partes deban o deseen
          hacerse en relación con estos Términos y Condiciones, deberán
          realizarse por correo electrónico, en el caso de aquellas dirigidos al
          usuario a la cuenta que se haya proporcionado al momento de su
          registro, y para aquellos dirigidos a Doowin S.A.S. a la cuenta de
          contacto señalada en este instrumento.
        </p>
        <p>
          El Usuario señala como su domicilio para todos los efectos legales que
          tuvieran lugar el expresado en el formulario de datos para su
          registro.
        </p>
        <p>
          Para la interpretación, cumplimiento y ejecución del presente
          instrumento, las partes se acogen a las Leyes colombianas y se someten
          a la jurisdicción ordinaria.
        </p>
        <p>
          <span class="title"
            >XIII. Autorización de investigación de historial crediticio y
            divulgación del mismo.</span
          >
          - El usuario a través de estos términos y condiciones autoriza
          expresamente a DOOWIN S.A.S ., para que lleve a cabo investigaciones
          sobre el comportamiento crediticio en las centrales de información
          crediticia que estime conveniente, por tanto, el usuario autoriza
          compartir su información personal con cualquier central de riesgo e
          información; como también su comportamiento crediticio con DOOWIN
          S.A.S.
        </p>
        <p>
          Por lo anterior, conoce la naturaleza y alcance de la información que
          se so licitará, del uso que se le dará y que se podrá realizar
          consultas periódicas del historial crediticio. Es así que a través de
          la aceptación de estos términos y condiciones tendrán una vigencia de
          3 años contados a partir de la aceptación de los mismos y e n su caso
          mientras subsista la relación contractual, por lo cual el usuario
          acepta que dicho documento quede en propiedad de Doowin S.A.S.
        </p>
        <p>
          <span class="title">XIV.</span>
          Centrales de información de riesgo crediticio. En caso de no realizar
          el pago en el tiempo estipulado y después de haber sido informado
          sobre el particular, la mora en la obligación será reportada a las
          centrales de riesgo crediticio, sin perjuicio de las demás acciones
          que se puedan adelantar para el cobro de las obligaciones a nuestro
          favor.
        </p>
        <p>
          Para efectos de la comunicación de aviso de reporte a las centrales de
          riesgo, remitiremos la información de manera escrita mediante
          cualquier tipo de mensaje de datos incluyendo SMS, correo electrónico,
          WhatsApp o cualquier medio del que quede registro para posteriores
          consultas.
        </p>
        <p>
          <span class="title">XV.</span>
          Las partes Acuerdan que el cliente podrá expresar su consentimiento
          respecto a los términos y condiciones, así como tener accesos a los
          servicios ofrecidos por DOOWIN S.A.S. y los terceros que considere
          para el cumplimiento del objeto.
        </p>
        <p>
          Habiendo leído y entendido cada uno de los Términos y Condiciones, el
          usuario manifiesta su total aceptación y sujeción a cualquier
          obligación de ellos derivada, al hacer uso de la Página Web y/o
          Aplicación.
        </p>
        <p>
          <span class="title">XVI.- Autorización de Cesión de Crédito.</span>
          - Autorizo irrevocablemente cualquier cesión que DOOWIN S.A.S en
          calidad de acreedor de las obligaciones, y en virtud de este contrato,
          haga con terceros, bien sean, personas naturales o jurídicas y en
          virtud de ello, una vez producida la cesión, declaro que exoneró a
          DOOWIN S.A.S, por cualquier actuación que en adelante realice el nuevo
          acreedor.
        </p>
      </div>
    </div>

    <footPage></footPage>
  </div>
</template>

<script>
import headNav from "@/components/headNav.vue";
import footPage from "@/components/foot.vue";
import "../components/scss/Aviso.scss";

export default {
  name: "loan",
  components: { headNav, footPage },
  data() {
    return {};
  },
};
</script>

<style scoped>
.content_title {
  font-size: 25px;
}
.titleNum {
  color: #1c9234;
  font-weight: 600;
}
.title {
  font-size: 30px !important;
  margin-top: 15px;
  font-weight: 600;
}
p {
  margin-bottom: 30px;
}
.bigContent {
  top: 133px;
  margin-top: 30px !important;
  box-shadow: 0px 0px 5px #ddd;
  padding-bottom: 0px;
  margin-bottom: 170px;
}
p span {
  color: #1c83ff;
  font-weight: 550;
}
</style>